import React, { ReactNode } from "react";
import { mergeStyleSets, useTheme } from "@fluentui/react";

interface PrivateLayoutProps {
  children: ReactNode;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = (props: PrivateLayoutProps) => {
  const { children } = props;
  const theme = useTheme();
  const privateLayoutStyles = mergeStyleSets({
    root: {
      display: "flex",
    },
    content: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      minWidth: 0,
      padding: "10px 10px",
      backgroundColor: theme.semanticColors.bodyBackground,
    },
  });
  return (
    <main className={privateLayoutStyles.root}>
      <>
        <div className={privateLayoutStyles.content}>{children}</div>
      </>
    </main>
  );
};

export default PrivateLayout;
